import { render, staticRenderFns } from "./UtilitiesMailingList.vue?vue&type=template&id=049ff30d&scoped=true"
import script from "./UtilitiesMailingList.vue?vue&type=script&lang=js"
export * from "./UtilitiesMailingList.vue?vue&type=script&lang=js"
import style0 from "./UtilitiesMailingList.vue?vue&type=style&index=0&id=049ff30d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049ff30d",
  null
  
)

export default component.exports